import { render, staticRenderFns } from "./good-category.vue?vue&type=template&id=a3b1ea9c&scoped=true&"
import script from "./good-category.vue?vue&type=script&lang=js&"
export * from "./good-category.vue?vue&type=script&lang=js&"
import style0 from "./good-category.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good-category.vue?vue&type=style&index=1&id=a3b1ea9c&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b1ea9c",
  null
  
)

export default component.exports